import { render, staticRenderFns } from "./DataTableLotes.vue?vue&type=template&id=5f0cd8f3&scoped=true"
import script from "./DataTableLotes.vue?vue&type=script&lang=js"
export * from "./DataTableLotes.vue?vue&type=script&lang=js"
import style0 from "./DataTableLotes.vue?vue&type=style&index=0&id=5f0cd8f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0cd8f3",
  null
  
)

export default component.exports